var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"task-list-item",on:{"click":_vm.editTask}},[_c('span',[_c('img',{attrs:{"src":require(("@/assets/icons/" + _vm.icon + ".svg")),"title":_vm.title,"height":"25"}}),_vm._v(" "+_vm._s(_vm.description)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }